module.exports = __webpack_public_path__ + "static/website-ee8e3ae4fa2558f416644ea223b1dbc3.png";